import React from "react"
import { graphql } from "gatsby"
import { Link } from "gatsby"
//import Layout from "../components/layout"
// import SEO from "../components/seo"
import {default as SeoComponent} from "../components/seo"
// import PostHeaderMeta from "../components/post-header-meta"
// import PostFooterMeta from "../components/post-footer-meta"
//import AniLink from "gatsby-plugin-transition-link/AniLink"
// import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import { navigate } from "gatsby";
// import { window, document } from 'browser-monads';
import SharePanel from "../components/share"
// import { useState, useEffect, useLayoutEffect } from 'react'
import styled from 'styled-components'
import moment from "moment/moment"
import 'moment/locale/it'
import he from 'he';
import { UrlsUtils } from "../utils/UrlsUtils";

// var regStr = 'http[s]*://(?!cdn)[a-z0-9A-Z.]*'+process.env.GATSBY_WPHOST+'/';
// var reg = new RegExp(regStr,"g");

const DivAnnounce = styled.div`
  box-sizing: border-box;
  border: 2px solid #E7E7E7;
  border-radius: 10px;
  width:316px;
  max-width:100%;
  height: 500px;
  margin: auto;
  position: relative;
  overflow:hidden
`

const ButtonNM = styled.div`
  border-radius: 7px;
  height: 52px;
  width: 90%;
  margin: auto;
  position: relative;
  line-height: 52px;
  background: linear-gradient(53.35deg, #EE3D49 0%, #CB356B 100%);
  color: #FFFFFF;
  font-family: "aktiv-grotesk";
  font-size: 19px;
  letter-spacing: 0.69px;
  text-align: center;
  font-weight: 800;
`


export const query = graphql`
  query AgendaPageQuery {
    site {
      siteMetadata {
        title
      }
    }
    www {
      events(
        where: {
          isAvaiableEvent: true,
          orderby: { field: DATE, order: ASC }
          status: PUBLISH
        }
        first: 12
      ) {
        nodes {
          id
          title
          excerpt
          uri
          link
          date
          content
          featuredImageTest
          duration
          address
          city
          startDate
          endDate
          externalLink
          province
          showMap
          zip
          venue {
            address
            city
            contentType {
              node {
                id
              }
            }
            content
            country
            desiredSlug
            isRestricted
            province
            showMapLink
            slug
            stateProvince
            state
            venueId
          }
        }
      }
    }
  }
`

//rest api json per ottenere anche i vecchi eventi (agenda) Vistato
//che graphql non li restituisce
//https://startupitalia.eu/wp-json/tribe/events/v1/events?start_date=2018-12-22%2000:59:00&end_date=2020-12-22%2000:59:00&orderby=start_date&order=DESC

const IndexPage = ({ data }) => {
  data.www.events &&
    data.www.events.nodes.sort(function (a, b) {
      var keyA = new Date(a.endDate),
        keyB = new Date(b.endDate)

      if (keyA < keyB) return -1
      if (keyA > keyB) return 1

      return 0
    });

  return (
    <div className="newmag-single-article">
      <SharePanel display="none" />
      <SeoComponent
        title={"Agenda - StartupItalia"}
        description={"Tutti gli eventi per le startup e investitori"}
      />
      <div
        className="newmag_agenda_img_header"
        style={{
          background: "rgba(11,1,53,0.76)",
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundImage: 'url("/img/agenda@2x.png")',
          marginLeft: "-4.7%",
          height: "310px",
          width: "110%",
        }}
      >
        <div
          className="newmag_agenda_big_title"
          style={{
            color: "white",
            height: "135px",
            width: "557px",
            fontFamily: "aktiv-grotesk",
            fontSize: "108px",
            letterSpacing: "2.4px",
            lineHeight: "139px",
            fontWeight: "800",
            paddingLeft: "145px",
            paddingTop: "59px",
          }}
        >
          Agenda
        </div>
      </div>
      <div
        className="newmag_agenda_search_header"
        style={{
          background: "linear-gradient(53.35deg, #EE3D49 0%, #CB356B 100%)",
          marginLeft: "-4.7%",
          height: "89px",
          width: "110%",
        }}
      >
        <div
          className="prova"
          style={{
            height: "135px",
            width: "100%",
            color: "#FFFFFF",
            fontFamily: "aktiv-grotesk",
            fontSize: "108px",
            letterSpacing: "2.4px",
            lineHeight: "139px",
            fontWeight: "800",
            paddingLeft: "82px",
          }}
        ></div>
      </div>
      <div
        className="newmag_agenda_spacer_header"
        style={{
          background: "",
          marginLeft: "-4.7%",
          height: "72px",
          width: "110%",
        }}
      >
        <div
          style={{
            height: "135px",
            width: "557px",
            color: "#FFFFFF",
            fontFamily: "aktiv-grotesk",
            fontSize: "108px",
            letterSpacing: "2.4px",
            lineHeight: "139px",
            fontWeight: "800",
            paddingLeft: "82px",
            paddingTop: "59px",
          }}
        ></div>
      </div>
      <article
        className={`newmag-article post-bandi post type-post status-publish format-standard hentry category-react tag-accessibility tag-gatsby entry`}
      >
        <div style={{ display: "none", width: "100%", height: "80px" }}>
          <div style={{ float: "right" }}>
            ORDINA PER <b style={{ marginLeft: "20px" }}>Data di scadenza</b>{" "}
            <span style={{ paddingTop: "30px", fontSize: "18px" }}>v</span>
          </div>
        </div>

        <div
          id="article_list"
          style={{
            marginBottom: "200px",
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(310px, 1fr))",
            gridGap: "28px",
          }}
        >
          {
            data.www.events &&
              data.www.events.nodes.map((announce) => (
                <DivAnnounce
                  className="newmag_agenda_card"
                  key={announce.link}
                  to={`${UrlsUtils.ensure_wp_admin_url(announce.link)}`}
                  rel="category"
                >
                  <Link to={UrlsUtils.ensure_wp_admin_url(announce.link)}>
                    <div
                      style={{
                        height: "180px",
                        width: "100%",
                        backgroundPosition: "center",
                        backgroundSize: "cover",
                        backgroundImage:
                          "url(" + announce.featuredImageTest + ")",
                      }}
                    ></div>
                  </Link>
                  <div
                    style={{
                      padding: "10px",
                      display: "flex",
                      flexDirection: "column",
                      height: "320px",
                      justifyContent: "space-between",
                    }}
                  >
                    {/* <div style={{height:"90px",color: '#232323', fontFamily: "aktiv-grotesk", fontSize: '20px', letterSpacing: 0 ,lineHeight: '22px', fontWeight:"800"}}>{he.decode(announce.title)} </div>
          <div style={{height:"80px", color: '#EE3D49',fontFamily: "aktiv-grotesk",fontSize: '30px', fontWeight: '800'}}>{moment(announce.startDate).locale('it').format(`D MMM YYYY`)} </div> */}
                    <div>
                      <h2
                        style={{
                          height: "100px",
                          color: "#232323",
                          fontFamily: "aktiv-grotesk",
                          fontSize: "20px",
                          letterSpacing: 0,
                          lineHeight: "22px",
                          fontWeight: "800",
                        }}
                      >
                        {he.decode(announce.title)}{" "}
                      </h2>
                      {/* <h2 style={{marginBottom: "16px", textAlign: "end", height:"30px", color: '#76778C',fontFamily: "urw-din",fontSize: '12px'}}>Chiude il <b>{moment(announce.closing).locale('it').format(`D MMM YYYY`)}</b> </h2> */}
                      <div
                        style={{
                          color: "#232323",
                          fontFamily: "aktiv-grotesk",
                          fontSize: "17px",
                          letterSpacing: "0",
                          lineHeight: "22px",
                          fontWeight: "800",
                          display: "flex",
                          alignContent: "center",
                          flexDirection: "row",
                        }}
                      >
                        <img
                          style={{ height: "1.5rem" }}
                          alt=""
                          src={"/img/calendar@2x.png"}
                        />
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignContent: "center",
                            flexDirection: "column",
                            marginLeft: "0.5rem",
                          }}
                        >
                          {moment(announce.startDate)
                            .locale("it")
                            .format(`D MMMM`)}{" "}
                          -{" "}
                          {moment(announce.endDate)
                            .locale("it")
                            .format(`D MMMM`)}
                        </div>
                      </div>
                      <div
                        style={{
                          color: "#232323",
                          fontFamily: "aktiv-grotesk",
                          fontSize: "17px",
                          letterSpacing: "0",
                          lineHeight: "22px",
                          fontWeight: "800",
                          display: "flex",
                          alignContent: "center",
                          flexDirection: "row",
                          marginTop: "0.5rem",
                        }}
                      >
                        <img
                          style={{ height: "1.5rem" }}
                          alt=""
                          src={"/img/pin@2x.png"}
                        />
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignContent: "center",
                            flexDirection: "column",
                            marginLeft: "0.5rem",
                          }}
                        >
                          {announce?.venue?.city ||
                          announce?.venue?.slug === "evento-virtuale"
                            ? "Evento Virtuale"
                            : ""}
                        </div>
                      </div>
                    </div>
                    {/* <div style={{height:"70px", color: '#EE3D49',fontFamily: "aktiv-grotesk",fontSize: '30px', fontWeight: '800'}}>{announce.address!=="false"?announce.address:""} </div> */}
                    <div style={{ marginBottom: "1rem" }}>
                      <Link to={UrlsUtils.ensure_wp_admin_url(announce.link)}>
                        <ButtonNM className="agenda-partecipa">Prendi il biglietto</ButtonNM>
                      </Link>
                    </div>
                  </div>
                </DivAnnounce>
              ))

            /*
      data.www.announcements.nodes.map((announce) => {
      return
        <div className="post-list" key={announce.title}>
          <h1>{announce.title}</h1>

          <span>{announce ? announce.title : "empty"}</span>
          <p></p>
        </div>
    })
*/
          }
        </div>
      </article>
    </div>
  )}
export default IndexPage
